import { getMappedEvents } from '../utils/getMappedEvents';

const EVENTS = [
  'createNewProjectClick',
  'newTranslationProjectSelected',
  'newRecordingProjectSelected',
  'extensionInstallPromptViewed',
  'extensionInstallClicked',
  'extensionInstallSuccess',
  'extensionDetected',
  'extensionOpened',
  'recordingPageViewed',
  'recordingStatusCompleted',
  'recordingStatusFailed',
  'recordingStatusAborted',
  'recordingTabSwitched',
  'recordingDownloadClicked',
  'recordingDownloadCompleted',
  'recordingDownloadFailed',
  'recordingRetryClicked',
  'recordingRated',
  'recordingFeedbackClicked',
  'desktopRequiredStateShown',
  'chromeRequiredStateShown',
  'recordingStartFromDashboardClickEntryPoint',
  'recordingStartFromExtensionClickEntryPoint',
  'extensionInstallClick',
  'extensionInstallPromptDismiss',
  'recordingIntroPromptViewed',
  'recordingIntroPromptDismiss',
  'recordingIntroRecordClick',
  'extensionSignInPromptViewed',
  'extensionSignInPromptProceedClick',
  'extensionSignInPromptCanceled',
  'extensionSignInSuccessful',
  'recordingProjectOpened',
  'recordingProjectProcessingScreenViewed',
  'recordingProjectProcessingFailed',
  'recordingProjectProcessingSucceeded',
  'recordingProjectResultScreenViewed',
  'recordingProjectExportClick',
  'recordingProjectDownloadClick',
  'recordingProjectDownloadSuccess',
  'recordingProjectShareClick',
  'recordingEditorOpened',
  'transcriptSpeechSegmentRemoved',
  'transcriptSpeechSegmentRestored',
  'recordingProjectLocalizeClick',
  'recordingProjectLocalizeSuccess',
  'recordingPermissionGranted',
  'recordingPermissionDenied',
  'recordingStarted',
  'recordingCompleted',
  'recordingCancelled',
  'recordingFailed',
  'recordingUploadFailed',
  'recordingSaved',
  'recordingPlaybackStarted',
  'recordingPlaybackStopped',
  'recordingPlayerError',
  'recordingRerenderCompleted',
  'recordingRerenderFailed',
  'recordingCheckoutActionCompleted',
] as const;

export const screenRecordEvents = getMappedEvents([...EVENTS], { shouldSendSubscriptionData: true });
